import React, {Component} from 'react';
import Page from '../../components/Page';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import {API_URL} from '../../constants'
import {setError} from '../../actions/global';
import './styles.css';


const DEFAULT_STATE = {
    project: '',
    year: moment().year(),
    month: moment().month()
};

const START_YEAR = 2016;

class Reports extends Component {

    constructor(props) {
        super(props);
        this.state = DEFAULT_STATE;
        this._onChangeSelect = this._onChangeSelect.bind(this);
        this._onClickDownloadReport = this._onClickDownloadReport.bind(this);
        this._fetchReportUrl = this._fetchReportUrl.bind(this);
        this._fetchReport = this._fetchReport.bind(this);

    }

    _onChangeSelect(property, option) {
        let value = (option && option.value) || '';
        if (property === 'month' && !value) {
            value = 0;
        }
        let state = Object.assign({}, this.state);
        state[property] = value;
        this.setState(state);
    }

    _fetchReportUrl() {
        let headers = {
            Accept: 'text/plain, */*',
        };
        headers['Authorization'] = this.props.token;
        const url = API_URL + '/generate?type=reports&year=' + this.state.year + '&month=' + this.state.month + '&project=' + this.state.project;
        return fetch(url, {
            method: 'GET',
            headers: headers,
        }).then(response => {
            if (response.ok) {
                return response.json().then(json => {
                    return Promise.resolve(json);
                });
            }
            return response.json().then(json => {
                return Promise.reject(json.message);
            });
        }, error => {
            if (error && typeof error === 'object') {
                if (error.message) {
                    error = error.message;
                } else {
                    error = JSON.stringify(error);
                }
            }
            return Promise.reject(error);
        });
    }

    _fetchReport(path) {

            // fake server request, getting the file url as response
            setTimeout(() => {
                const response = {
                    file: API_URL + path,
                };
                // server sent the url to the file!
                // now, let's download:
                window.open(response.file);
                // you could also do:
                // window.location.href = response.file;
            }, 100);
    }

    _onClickDownloadReport() {
        this._fetchReportUrl().then(json => {
            if (json && json[0]) {
                this._fetchReport(json[0]);
            } else {
                this.props.dispatch(setError('No report was generated for this selection.'));
            }
        }).catch(error => {
            this.props.dispatch(setError(error || 'Could not generate the report. Please try again.'));
        });
    }

    render() {

        let disabled = !((this.state.project !== '') && (this.state.year !== '') && (this.state.month !== ''));

        let projects = this.props.projects.map(project => {
           return {label: project.name, value: project._id};
        });
        let months = moment.months().map((month, index) => {
            return {label: month, value: index};
        });
        let years = [];
        for (let i = START_YEAR; i <= moment().year(); i++) {
            years.push({label: i.toString(), value: i});
        }
        return (
            <Page {...this.props} >
                <div className="col-xs-12">
                    <div className="Card" style={{maxWidth: '560px'}}>
                        <div className="Title"><span>Generate report</span></div>

                        <div className="Input-Group">
                            <label>Project</label>
                            <Select
                                name="project"
                                value={this.state.project}
                                onChange={(option) => this._onChangeSelect('project', option)}
                                options={projects}
                                placeholder="Select a project"
                            />
                        </div>

                        <div className="Field-Row">
                            <div className="Input-Group">
                                <label>Month</label>
                                <Select
                                    name="month"
                                    value={this.state.month}
                                    onChange={(option) => this._onChangeSelect('month', option)}
                                    options={months}
                                />
                            </div>
                            <div className="Input-Group">
                                <label>Year</label>
                                <Select
                                    name="year"
                                    value={this.state.year}
                                    onChange={(option) => this._onChangeSelect('year', option)}
                                    options={years}
                                />
                            </div>
                        </div>

                        <div style={{textAlign: 'right', paddingTop: '6px'}}>
                            <button disabled={disabled} onClick={this._onClickDownloadReport} className="btn btn-primary">
                                <i className="fa fa-download" aria-hidden="true" /> Download report
                            </button>
                        </div>
                    </div>
                </div>
            </Page>
        );
    }
}

Reports.propTypes = {
    projects: PropTypes.arrayOf(PropTypes.object),
    token: PropTypes.string,
};

Reports.defaultProps = {
    projects: [],
    token: ''
};


function mapStateToProps(state) {
    const projects = state.projects;
    const token = state.authentication.token;
    return {
        projects: projects,
        token: token,
    };
}

export default connect(mapStateToProps)(Reports);



// WEBPACK FOOTER //
// ./src/screens/Reports/index.js